<template>
  <button
    class="flashcard-footer-button"
    @click="handleBookmarkClick"
  >
    <icon
      v-if="hasBookmark"
      name="flag-filled"
      :variant="variant"
      class="flashcard-footer-icon"
    ></icon>
    <icon
      v-else
      name="flag-outline"
      :variant="variant"
      class="flashcard-footer-icon"
    ></icon>
    Flag
  </button>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    hasBookmark: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'ffffff',
    },
  },
  methods: {
    handleBookmarkClick() {
      this.$emit('toggle-bookmark');
    },
  },
};
</script>

<style lang="scss" scoped>
.flashcard-footer-button {
  background: none;
  border: none;
  border-right: 1px solid #e5e5e5;
  color: white;
  cursor: pointer;
  font-size: 1.25rem;
  padding: 0;
  padding-right: 1rem;
  text-align: left;
  display: flex;
  align-items: center;

  .flashcard-footer-icon {
    margin-right: 0.5rem;
    height: 1.25rem;
  }
}
</style>
